import ModalContent, {
  type OrgSettingPropagationModalProps,
} from './OrgSettingPropagationModalContent';

const OrgSettingPropagationModal = ({
  closeModal,
  isOpen,
  options,
}: OrgSettingPropagationModalProps) => {
  if (!isOpen) return null;
  return <ModalContent isOpen={isOpen} closeModal={closeModal} options={options} />;
};

export default OrgSettingPropagationModal;
